/* eslint-disable global-require */
// import './wdr'
import r2wc from "@r2wc/react-to-web-component";
import 'react-circular-progressbar/dist/styles.css';
import 'react-image-lightbox/style.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'video.js/dist/video-js.css';
import WordPressEmbedded from './views/wordpress/WordPressEmbedded';
import axios from "axios";



export const backendApi = axios.create({});

const AppWebComponent = r2wc(WordPressEmbedded, {
  props: {
    clientId: "string",
    apiKey: "string",
    page: "string",
  },
});

if (!customElements.get("arbute-client")) {
  customElements.define("arbute-client", AppWebComponent);
  
}
